import { createContext } from 'react';
import { CreateOwnerContractData } from '@/custom-types';
import { OwnerContractLeaseTypeOption, PaymentFrequencyOption } from '@/graphql/generated';

export type CreateOwnerContractContextValue = {
  state: CreateOwnerContractData;
  setOwner: (ownerId: string, ownerName: string) => void;
  setProperty: (propertyId: string, propertyName: string) => void;
  setLeaseType: (leaseType: OwnerContractLeaseTypeOption) => void;
  setInsuranceId: (insuranceId: string | null) => void;
  setContractAmount: (amount: string | null) => void;
  setFrequencyPayment: (frequencyPayment: PaymentFrequencyOption) => void;
  setDates: (startDate: string | null, finishDate: string | null) => void;
  setButtonDisabled: () => void;
  setButtonEnabled: () => void;
  buttonState: boolean;
};

export const CreateOwnerContractContext =
  createContext<CreateOwnerContractContextValue | null>(null);

